import { defineMessages } from 'react-intl'

export default defineMessages({
  assetId: {
    defaultMessage: 'Asset ID',
    description: 'Smart Shares table history tab | share id column header',
  },
  bridgeDateFrom: {
    defaultMessage: 'Bridge Start',
    description: 'Smart Shares table history tab | share bridge start column header',
  },
  bridgeDateTo: {
    defaultMessage: 'Bridge End',
    description: 'Smart Shares table history tab | share bridge end column header',
  },
  description: {
    defaultMessage: 'Description',
    description: 'Smart Shares table history tab | share description column header',
  },
  plateNumber: {
    defaultMessage: 'License Plate',
    description: 'Smart Shares table history tab | share license plate column header',
  },
  reference: {
    defaultMessage: 'Reference No',
    description: 'Smart Shares table history tab | share reference column header',
  },
  in: {
    defaultMessage: 'IN',
    description: 'Smart Shares table history tab | share type column header',
  },
  invoice: {
    defaultMessage: 'Invoice',
    description: 'Smart Shares table history tab | share description column header',
  },
  out: {
    defaultMessage: 'OUT',
    description: 'Smart Shares table history tab | share type column header',
  },
  owner: {
    defaultMessage: 'Organisation From/To',
    description: 'Smart Shares table history tab | share owner column header',
  },
  sub: {
    defaultMessage: 'SUB',
    description: 'Badge text | Table badge text',
  },
  type: {
    defaultMessage: 'Type',
    description: 'Badge text | Table badge text',
  },
})
